import React, { useEffect, useState } from "react";
import { Box, Button, CircularProgress, Stack } from "@mui/material";
import MaterialModal from "../../../app/material-modal";
import ViewSettingsTable from "./ViewSettingsTable";
import { cohortPolicyConfig } from "../../../../constants";
import { useUpdateGroupPolicy } from "../../../../tanstackQuery/queries/superAdmin/group";
import { toast } from "sonner";
import { useKeycloak } from "@react-keycloak/web";
import { useQueryClient } from "@tanstack/react-query";

export function ViewSettingsModal({cohortDetails}) {

  const [open, setOpen] = React.useState(false);
  const [policyState, setPolicyState] = useState<Record<string, boolean>>({});
  const { keycloak } = useKeycloak();
  const client = useQueryClient();

  useEffect(() => {
    const updatedPolicyState = Object.entries(cohortPolicyConfig).reduce(
      (acc, [_, key]) => {
        acc[key] = Boolean(cohortDetails[key]); 
        return acc;
      },
      {} as Record<string, boolean>
    );
    setPolicyState(updatedPolicyState);
  }, [cohortDetails,open]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const {
    mutateAsync: updateGroupPolicy,
    isPending,
    isSuccess,
  } = useUpdateGroupPolicy(
    { accessToken: keycloak?.token },
    {
      onSuccess: () => {
        client.invalidateQueries({ queryKey: ["orgtree"] });
        client.invalidateQueries({ queryKey: ["group-details"] });
        handleClose();
      },
    }
  );

  const handleMoveUser = async () => {
    try {
      await updateGroupPolicy({
        payload : policyState,
        groupID: cohortDetails?.groupID
      });
      if (isSuccess) {
        toast.success("Group policy successfully update!");
        handleClose();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to update Group policy.");
    }
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Button fullWidth variant="contained" onClick={handleOpen}>
        Edit View Stettings
      </Button>
      <MaterialModal
        open={open}
        handleDialogClose={handleClose}
        styleOverrides={{
          container: {
            "& .MuiDialog-paper": {
              width: "100%",
              minHeight: "500px",
              minWidth: "800px",
              ".MuiDialogContent-root": {
                overflow: "auto",
              },
            },
          },
        }}
        title="Cohort Settings"
      >
        <Box>
          <ViewSettingsTable
            policyState={policyState}
            setPolicyState={setPolicyState}
          />
          <Stack direction="row" justifyContent="flex-end" gap={1}>
            <Button variant="outlined" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              variant="contained"
              disabled={isPending}
              endIcon={isPending ? <CircularProgress size={16} /> : null}
              onClick={handleMoveUser}
            >
              Update
            </Button>
          </Stack>
        </Box>
      </MaterialModal>
    </Box>
  );
}
